import React from "react";
const projects = [
    {
        image: "/wp-content/themes/en-theme/assets/src/images/tim.svg",
        url: "tim-osterreich.at",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/salzburgerfestspiele.png",
        url: "salzburgerfestspiele.at",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/hoerakustiker-steiermark.svg",
        url: "hoerakustiker-steiermark.at",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/tippingpoint.png",
        url: "tippingpoint.org",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/waff.png",
        url: "waff.at",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/social-innovation-tournament.png",
        url: "sit2022.org",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/sfg.png",
        url: "sfg.at",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/engarde.jpg",
        url: "engarde.net",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/4oh4.svg",
        url: "4oh4.at",
    },
    // {
    //     image: "/wp-content/themes/en-theme/assets/src/images/albanco.svg",
    //     url: "albanco.at",
    // },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/erstestiftung.png",
        url: "erstestiftung.org",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/eventery.svg",
        url: "erstecampus.at",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/george.png",
        url: "cafegeorge.at",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/iki.png",
        url: "iki-restaurant.at",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/optiker-steiermark.svg",
        url: "optiker-steiermark.at",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/a1-brand-portal.jpg",
        url: "brand.a1.group",
    },
    {
        image: "/wp-content/themes/en-theme/assets/src/images/a1-brand-land.png",
        url: "", // a1brandland.com
    },
];

const Portfolio = function () {
    return (
        <div className="portfolio container">
            <div className="portfolio__header">
                <div className="portfolio__avatar">
                    <img src="/wp-content/themes/en-theme/assets/src/images/avatar.png" />
                </div>
                <div className="portfolio__info">
                    <div className="portfolio__header-top">
                        <h1>Dominik Kadežabek</h1>
                        <p className="portfolio__position">React Developer</p>
                    </div>
                    <div className="portfolio__contact">
                        <p>
                            <i class="fa-solid fa-phone"></i>{" "}
                            <a href="tel:+43 676 706 5030">+43 676 706 5030</a>
                        </p>
                        <p>
                            <i class="fa-solid fa-envelope"></i>{" "}
                            <a href="mailto:kadezabek.dominik@gmail.com">
                                kadezabek.dominik@gmail.com
                            </a>
                        </p>
                        <p>
                            <i class="fa-brands fa-linkedin"></i>&nbsp;
                            <a href="//www.linkedin.com/in/dkadezabek">
                                linkedin.com/in/dkadezabek
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div className="portfolio__content">
                <section className="portfolio__section">
                    <h2>Relevant Experience</h2>
                    <ul>
                        <li>
                            React, TypeScript, ES6 - I used React for Erste
                            Campus restaurants (if you go there and see the
                            screens with meals, think of me)
                        </li>
                        <li>
                            Jira, Confluence - We did use it, but I have to be
                            honest not to the full extent
                        </li>
                        <li>
                            WCAG/A11Y, I had to implement a11y features on some
                            of the projects
                        </li>
                        <li>Git - pretty good experience</li>
                    </ul>
                </section>
                <section className="portfolio__section">
                    <h2>Technical Knowledge</h2>
                    <ul>
                        <li>
                            Very good experience in HTML, S/CSS, Javascript,
                            PHP, MySQL, WordPress, Git
                        </li>
                        <li>
                            Good experience with React, Next.js, a little bit of
                            experience of Typescript, Webpack, NodeJS
                        </li>
                    </ul>
                </section>
                <section className="portfolio__section">
                    <h2>Other skills</h2>
                    <ul>
                        <li>English (C1), German (~B1), Croatian (Native)</li>
                        <li>Basics of Photoshop, Illustrator</li>
                    </ul>
                </section>
                <section className="portfolio__section">
                    <h2>Education</h2>
                    <div className="portfolio__subsection">
                        <div className="portfolio__subsection-header">
                            <h3>
                                Management in Small and Medium Sized Enterprises
                                <small> (MA)</small>
                            </h3>
                            <small>(2016 - 2019)</small>
                        </div>
                        <ul>
                            <li>Dissertation: Influencer marketing</li>
                            <li>
                                Best Presentation Award - International Business
                                Week
                                <small>
                                    (Institute of Technology and Business in
                                    České Budějovice)
                                </small>
                            </li>
                            <li>
                                Coauthored: Impact of influencer marketing on
                                consumer behaviour <br />
                                <small>
                                    (42nd International Scientific Conference on
                                    Economic and Social Development – London)
                                </small>
                            </li>
                        </ul>
                    </div>
                    <div className="portfolio__subsection">
                        <div className="portfolio__subsection-header">
                            <h3>
                                Management in Computer Science
                                <small> (BA)</small>
                            </h3>
                            <small>(2013 - 2016)</small>
                        </div>
                        <ul>
                            <li>
                                Dissertation: Prototype of a simple web content
                                management system
                            </li>
                            <li>Student Unions' representative</li>
                            <li>Member of Croatian student council</li>
                            <li>Demonstrator for Databases course</li>
                        </ul>
                    </div>
                </section>
                {/* <section className="portfolio__section">
                    <h2>Personality traits</h2>
                    <ul>
                        <li>great communication skills</li>
                        <li>critical thinking</li>
                        <li>problem solving</li>
                    </ul>
                </section> */}
                <section className="portfolio__section">
                    <h2>Career History</h2>
                    <div className="portfolio__subsection">
                        <div className="portfolio__subsection-header">
                            <h3>Web Development | EN GARDE</h3>
                            <p>
                                <small>(Apr. 2019 - present)</small>
                            </p>
                        </div>
                        <p>
                            At first it was an Erasmus Internship, but it didn't
                            take long for us to bring the cooperation to the
                            next level. En Garde is the company where my
                            development skills rose to a completely new level,
                            and the place where I had the opportunity to work
                            with bigger clients.
                        </p>
                        <p>
                            Some projects are: <br />
                            waff.at, sfg.at, tim-osterreich.at,
                            salzburgerfestspiele.at,
                            hoerakustiker-steiermark.at, tippingpoint.org, En
                            Garde internal framework, engarde.net,
                            erstecampus.at, erstestiftung.org, 4oh4.at,
                            brand.a1.group,...
                        </p>

                        <div className="en-chips">
                            {projects.map((project) => {
                                return (
                                    <a
                                        href={project.url}
                                        className="chip"
                                        title={project.url}
                                    >
                                        <img
                                            className="chip__image"
                                            src={project.image}
                                        />
                                        {/* <span>{project.url}</span> */}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                    <div className="portfolio__subsection">
                        <div className="portfolio__subsection-header">
                            <h3>Project Management (IT) | factory.hr</h3>
                            <p>
                                <small>(Jul. 2018 - Oct. 2018)</small>
                            </p>
                        </div>
                        <p>
                            Initally it was an internship, but then I got a job
                            offer. My job consisted of communication between
                            clients, developers, QA, designers and superiors. I
                            also defined user experience flow (with designers),
                            documented projects, made reports, defined schedule,
                            estimated development time with developers, took
                            care of the budget and deadlines. Projects I was
                            working on were danasradim.hr, danasradim.ba,
                            burzahrane.hr and dinocop.hr.
                        </p>
                    </div>
                    <div className="portfolio__subsection">
                        <div className="portfolio__subsection-header">
                            <h3>Web Development | avoco.hr</h3>
                            <p>
                                <small>(Sep. 2016 - Jun. 2018)</small>
                            </p>
                        </div>
                        <p>
                            Here I officially started my web development career.
                            I was developing custom websites using WordPress. We
                            used HTML, S/CSS, jQuery, PHP, MySQL, Bootstrap,...
                            Some projects: hrvatski-bocarski-savez.hr,
                            montessy.com (plugin development).
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Portfolio;
